/**
 * Used with App shell: viewport column + main { flex: 1 } so marketing pages
 * fill the space between header and footer.
 */
export const marketingPageRootSx = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  width: "100%",
  minHeight: 0,
};

export const marketingContainerSx = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
};
